import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import Icon from '../../components/Icon';
import usePageTitle from '../../hooks/usePageTitle';
import { getRegion } from '../../data/locations';
import NotFound from './NotFound';

export default function LocationRegion() {
  const { t } = useTranslation();
  const { region: slug } = useParams();
  const region = getRegion(slug);
  const steps = t('locationRegion.steps', { returnObjects: true });

  usePageTitle(region ? t('locationRegion.pageTitle', { name: region.name }) : t('locationRegion.genericTitle'));

  if (!region) return <NotFound />;

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{region.country}</span>
            <h1>{t('locationRegion.title', { name: region.name })}</h1>
            <p className="lede">{region.lede}</p>
            <div className="hero-actions">
              <Link className="btn btn-primary btn-lg" to="/register/family">{t('locationRegion.requestNanny')}</Link>
              <Link className="btn btn-outline btn-lg" to="/contact">{t('locationRegion.contactUs')}</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="two-col">
            <Reveal>
              <span className="eyebrow">{t('locationRegion.areasWeCover')}</span>
              <h2>{t('locationRegion.townsTitle', { name: region.name })}</h2>
              <p className="section-lede">{t('locationRegion.townsLede')}</p>
            </Reveal>
            <Reveal delay={120}>
              <ul className="check-list">
                {region.cities.map((city) => (
                  <li key={city}>
                    <span className="check-mark">
                      <Icon name="check" size={14} strokeWidth={2.2} />
                    </span>
                    {city}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <Reveal className="section-head">
            <span className="eyebrow">{t('locationRegion.howItWorksHere')}</span>
            <h2>{t('locationRegion.stepsTitle')}</h2>
          </Reveal>
          <ol className="steps">
            {steps.map((step, i) => (
              <Reveal as="li" key={step.title} className="step" delay={i * 110}>
                <span className="step-number">{i + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="cta-band">
            <div>
              <h2>{t('locationRegion.needNannyTitle', { name: region.name })}</h2>
              <p>{t('locationRegion.needNannyBody')}</p>
            </div>
            <div className="cta-actions">
              <Link className="btn btn-primary btn-lg" to="/register/family">{t('locationRegion.getStarted')}</Link>
              <Link className="btn btn-outline" to="/locations">{t('locationRegion.allLocations')}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
